import type { JSX } from "react";
import type { DeviceProfile } from "../types";
import { formatNumber } from "./format";
import { SectionTable } from "./SectionTable";

export const PlatformPanel = ({
  profile,
}: {
  profile: DeviceProfile;
}): JSX.Element => (
  <SectionTable
    headers={["Platform", "Device type", "Model", "Count"]}
    rows={profile.platforms.map((row) => [
      row.platform,
      row.deviceType,
      row.model,
      formatNumber(row.count),
    ])}
    emptyLabel="No platform data."
  />
);
